<a target="_blank"
   [href]="registerLink"
   [className]='className'
   [textContent]="nameRegisterBtn"></a>
